import { Market } from "../../contracts";
import { MainMarketsTypes } from "../../data";

export const getMarketTypeId = (market: Market): string => {
    let marketTypeId = market.marketType.id;

    if (marketTypeId.startsWith(`${MainMarketsTypes.ML.toString()}_`)
        || marketTypeId.startsWith(`${MainMarketsTypes.HC.toString()}_`)
        || marketTypeId.startsWith(`${MainMarketsTypes.OU.toString()}_`)) {
        return marketTypeId.substring(2, marketTypeId.length);
    }

    return marketTypeId;
}